// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__M5FvX","header":"PatientQuestionnaire_header__2loft","info":"PatientQuestionnaire_info__1siHP"};